export default "__VITE_ASSET__BS4o0U0k__"